<template>
    <div class="conss">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/mine' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/mine' }">我的订单</el-breadcrumb-item>
            <el-breadcrumb-item>订单号 {{info.order_no}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="background-color: #fff;margin-top: 16px;box-sizing: border-box;padding: 30px;text-align:left">
            <div class="aotitle">
                订单状态
            </div>
            <div class="par1">
                <div class="patItem flx alc">
                    <div class="parleft">
                        订单状态:
                    </div>
                    <div class="parright" v-text="info.order_status_text2">

                    </div>
                </div>

                <div class="patItem flx alc" style="margin: 20px 0;">
                    <div class="parleft">
                        订单编号:
                    </div>
                    <div class="parright" v-text="info.order_no">

                    </div>
                </div>

                <div class="patItem flx alc">
                    <div class="parleft">
                        创建时间:
                    </div>
                    <div class="parright" v-text="info.createtime_text">

                    </div>
                </div>
            </div>
            <div class="aotitle">
                活动信息
            </div>
            <div class="par2 flx alc">
                <div class="parimg">
                    <img :src="$img(info.avatar)" alt="" />
                </div>
                <div class="parinfo">
                    <div class="parname" v-text="info.name">

                    </div>
                    <div class="infItem flx alc">
                        <img :src="$Localimg('id1.png')" alt="" />
                        <span v-text="info.time_text"></span>
                    </div>

                    <div class="infItem flx alc">
                        <img :src="$Localimg('id2.png')" alt="" />
                        <span v-text="info.address"></span>
                    </div>
                </div>
            </div>
            <div class="aotitle">
                报名人信息
            </div>
            <div class="par3">
                <div class="parite">
                    <div class="prtleft">
                        姓名
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        手机号
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].tel">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].email">
                    <div class="prtleft">
                        邮箱
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].email">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        企业名称
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].company_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        岗位职务
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].position_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        行业类型
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].industry_name">

                    </div>
                </div>
                <div class="parite">
                    <div class="prtleft">
                        所在地区
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].address">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].demand">
                    <div class="prtleft">
                        需求
                    </div>
                    <div class="prtright"
                        v-text="info.activity_registration[0].demand?info.activity_registration[0].demand : ''">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].id_img">
                    <div class="prtleft">
                        身份验证
                    </div>
                    <div class="prtright">
                        <img :src="$img(info.activity_registration[0].id_img)" alt="" />
                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].promoter">
                    <div class="prtleft">
                        推荐人姓名
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].promoter">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].wx_number">
                    <div class="prtleft">
                        微信
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].wx_number">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].qq">
                    <div class="prtleft">
                        QQ
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].qq">

                    </div>
                </div>
                <div class="parite" v-if="info.activity_registration[0].ed">
                    <div class="prtleft">
                        学历
                    </div>
                    <div class="prtright" v-text="info.activity_registration[0].ed">

                    </div>
                </div>
            </div>
            <div class="prices">
                <div class="priceItem flx alc">
                    <div class="pricename" v-text="info.order_status == 0?'需付款':'已付款'"></div>
                    <div class="priceVal" style="font-weight: bold;font-size: 18px;" v-text="`￥${info.total_price}`">
            
                    </div>
                </div>
            </div>
            <div class="btns">
                  <el-button @click="repays" v-if="info.order_status == 0" type="primary">马上支付</el-button>
                  <el-button @click="cancelOrder" v-if="info.order_status == 0">取消订单</el-button>
            </div>
        </div>
        <wechatpay @rfh="getDetail" v-if="showALert" @close="showALert=false" :type="'activity'" :source="'repay'" :orderNo="info.order_no" :codeUrl="pay_code_url"></wechatpay>
    </div>
</template>

<script>
    import {
        acorderdetail,
        cencelaORder,
        repayaorder
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    export default {
        name: 'OrderDetail',
        components: {
            wechatpay
        },
        data() {
            return {
                info: {},
                showALert:false,
                pay_code_url:""
            }
        },
        mounted() {
            this.getDetail()
        },
        methods: {
            repays(){
                let that = this
                 let data = {}
                 data.order_id = that.$route.query.id
                 repayaorder(data).then((res) => {
                     console.log(res)
                     if(res.code == 1){
                         that.pay_code_url = res.data.code_url
                         that.info.order_no = res.data.order_no
                         that.showALert = true
                     }else{
                         that.$message({
                             type: 'error',
                             message: res.msg
                         });
                     }
                 })
            },
            cancelOrder(e){
                let that = this
                let data = that.$route.query.id
                that.$confirm('确定要取消该订单吗?', ' ', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cencelaORder(data).then((res) => {
                        if(res.code == 1){
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getDetail()
                        }else{
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {
                   
                });
               
            },
            getDetail() {
                let that = this
                let data = that.$route.query.id
                acorderdetail(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.info = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pricename {
        font-size: 14px;
        color: #666666;
    
    }
    
    .priceVal {
        width: 93px;
        font-size: 14px;
        color: #FF0F23;
        line-height: 21px;
        text-align: right;
    }
    
    .priceItem {
        justify-content: flex-end;
        margin-top: 30px;
    }
    
    .parite {
        display: flex;
        align-items: center;
        margin-bottom: 36px;
    }

    .prtleft {
        width: 385px;
        text-align: right;
        margin-right: 16px;
        font-size: 14px;
        color: #48576A;
        
    }

    .prtright {
        font-size: 14px;
        color: #141933;
    }

    .prtright img {
        width: 516px;
        height: 252px;
        border-radius: 4px 4px 4px 4px;
        object-fit: cover;
    }

    .infItem {
        font-size: 14px;
        color: #1F2937;
        margin-top: 12px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .parname {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .parimg {
        width: 172px;
        height: 97px;
        margin-right: 16px;
    }

    .parimg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;

    }

    .par2 {
        box-sizing: border-box;
        padding: 30px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .parleft {
        font-size: 14px;
        color: #48576A;
        margin-right: 20px;
    }

    .parright {
        font-weight: 600;
        font-size: 14px;
        color: #141933;
    }

    .par1 {
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 50px;
    }

    .aotitle {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-bottom: 22px;
    }

    .conss {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
    }
</style>